import { format, formatDistanceToNow, isThisYear, isToday, isYesterday } from "date-fns"

export function formatDateTime(timestamp: number, full = false, withSeconds = false) {
  const date = new Date(timestamp)
  const timeFormat = withSeconds ? "HH:mm:ss" : "HH:mm"
  const enUS = navigator.language == "en-US"

  if (full) {
    return format(date, enUS ? `MM/dd/yyyy ${timeFormat}` : `dd.MM.yyyy ${timeFormat}`)
  }

  if (isToday(date)) {
    return format(date, timeFormat)
  }

  if (isThisYear(date)) {
    return format(date, enUS ? `MMM d ${timeFormat}` : `d MMM ${timeFormat}`)
  }

  return format(date, enUS ? `MM/dd/yyyy ${timeFormat}` : `dd.MM.yyyy ${timeFormat}`)
}

export function formatDate(timestamp: number, full = false) {
  const date = new Date(timestamp)
  const enUS = navigator.language == "en-US"

  if (full) {
    return format(date, enUS ? "MM/dd/yyyy" : "dd.MM.yyyy")
  }

  if (isToday(date)) {
    return "Today"
  }

  if (isYesterday(date)) {
    return "Yesterday"
  }

  if (isThisYear(date)) {
    return format(date, enUS ? "MMM d" : "d MMM")
  }

  return format(date, enUS ? "MM/dd/yyyy" : "dd.MM.yyyy")
}

export function formatTime(timestamp: number, full = false) {
  const date = new Date(timestamp)
  const now = Date.now()

  if (full) {
    return format(date, "HH:mm")
  }

  if (now - date.getTime() < 60 * 1000) {
    return "just now"
  }

  if (now - date.getTime() < 10 * 60 * 1000) {
    return formatDistanceToNow(date, { addSuffix: true })
  }

  return format(date, "HH:mm")
}

export function formatDuration(ms: number) {
  if (ms < 1000) {
    return `${ms} ms`
  } else if (ms < 60_000) {
    return `${Math.floor(ms / 1000)} s`
  } else if (ms < 3_600_000) {
    return `${Math.floor(ms / 60_000)} min`
  } else if (ms < 86_400_000) {
    return `${Math.floor(ms / 3_600_000)} h`
  } else {
    return `${Math.floor(ms / 86_400_000)} d`
  }
}
